export default __webpack_public_path__ + "static/media/outsourcing-icon1.09cd5e0a.svg";